import styled from 'styled-components'

const New = styled.h4`
  color: red !important;
`

export default New
